<template>
  <AppRuntimeConfigOverlay v-if="runtimeLoading || runtimeError || !runtimeLoaded" />
  <template v-else>
    <AppRouteLoader />
    <router-view/>
    <PrimevueConfirmDialog />
    <AppDismissibleAlerts />
    <AppToastHost />
    <AppReleaseNotesDialog v-if="isBackofficeAudience" />
  </template>
</template>

<script>
import AppDismissibleAlerts from '@/components/AppDismissibleAlerts.vue';
import AppRouteLoader from '@/components/AppRouteLoader.vue';
import AppReleaseNotesDialog from '@/components/AppReleaseNotesDialog.vue';
import AppToastHost from '@/components/AppToastHost.vue';
import AppRuntimeConfigOverlay from '@/components/AppRuntimeConfigOverlay.vue';

export default {
  name: 'App',
  components: {
    AppDismissibleAlerts,
    AppRouteLoader,
    AppReleaseNotesDialog,
    AppToastHost,
    AppRuntimeConfigOverlay,
  },
  computed: {
    isBackofficeAudience() {
      return this.$route?.meta?.audience !== 'public' && /^\/backoffice(?:\/|$)/.test(this.$route?.path || '');
    },
    runtimeLoaded() {
      return Boolean(this.$store.getters['runtime/isLoaded']);
    },
    runtimeLoading() {
      return Boolean(this.$store.getters['runtime/isLoading']);
    },
    runtimeError() {
      return Boolean(this.$store.getters['runtime/loadError']);
    },
  },
};
</script>
